module.exports = __webpack_public_path__ + "img/user-img-default.03a0d2bd.svg";